import { cn } from "@edusogno/lib/utils";

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const RegistrationContainer = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        "flex flex-col flex-[4_0_40%] lg:max-w-[55%] lg:min-w-[500px] mx-auto p-5 w-full items-center",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default RegistrationContainer;
